import { GenericBasket, Status } from '@/types';
import { fetchBasket } from '@/utils/http/fetchBasket';
import { Thunk } from '@/redux/types';
import { BasketAction, BasketActionTypes } from '../types';

export const loadBasketAction =
  (basketId: string): Thunk<Promise<void>, BasketAction> =>
  async (dispatch) => {
    let basket: GenericBasket = { items: [] };
    let status: Status = 'initial';

    if (basketId) {
      dispatch({
        type: BasketActionTypes.SET_BASKET_STATUS,
        status: 'loading',
      });

      try {
        basket = await fetchBasket(basketId);
        status = 'success';
      } catch (e) {
        status = 'error';
      }
    }

    dispatch({
      type: BasketActionTypes.SET_BASKET,
      payload: basket,
      status,
    });
  };
